/* eslint-disable max-len */
import { FC } from "react";

import {
  BarChart as RechartsBarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { IChart } from "domains/altCustody/shared/types";
import CustomChartTooltip from "domains/altCustody/components/CustomChartTooltip";
import { ChartType } from "domains/altCustody/shared/constants";
import { formatCurrency } from "common/shared/helpers";

interface IProps {
  data: IChart["data"];
  activeIndex: number | undefined;
  onChartFragmentClick: (activeChartInfo: { entry: IChart["data"][0]; activeIndex: number } | undefined) => void;
}

const formatValue = (value: string) => {
  return value.trim().length > 15 ? value.slice(0, 20).trim() + '...' : value.trim() + ' .';
};

const BarChart: FC<IProps> = ({ data, activeIndex, onChartFragmentClick }) => {
  const isFundInvestment = data[ 0 ].name.includes('Investor NAV')
  const correctNegative = data.length > 1 ? data.map((item: any) => {
    return {
      ...item,
      value: item.isNegative ? -Math.abs(item.value) : item.value,
    };
  }) : data;
  return (
    <ResponsiveContainer aspect={ 1 }>
      <RechartsBarChart data={ correctNegative }>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey={ isFundInvestment ? "barValue" : "name" }
          y={ 5 }
          angle={ -90 } // Rota las etiquetas a 45 grados
          textAnchor="end" // Las etiquetas se alinean al final
          interval={ 0 } // Asegura que todas las etiquetas sean visibles
          tick={ { fontSize: 10, y: 10 } } // Controla el tamaño de las fuentes
          tickFormatter={ isFundInvestment ? (value) => formatCurrency(value) : (value) => formatValue(value) } // Asegura que las etiquetas no sean truncadas por el formato
          height={ 100 } // Asigna un tamaño de altura mayor para las etiquetas
        />
        <Bar
          cursor={ "pointer" }
          dataKey="value"
          fill="#8884d8"
          activeIndex={ activeIndex }
          activeBar={ <Rectangle fill="pink" stroke="blue" /> }
          onClick={ (data, index) => {
            if (activeIndex === index) {
              onChartFragmentClick(undefined);
              return;
            }

            onChartFragmentClick({ entry: data, activeIndex: index });
          } }
        />

        {data.length === 0 && <Bar dataKey="name" data={ [ { name: "No Data", value: 1 } ] } fill="#eeeeee" />}

        {data.length !== 0 && (
          <Tooltip content={ <CustomChartTooltip type={ ChartType.BAR } /> } cursor={ { fill: "transparent" } } />
        )}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
};

export default BarChart;
